<span
	class="hover:cursor-pointer hover:text-transparent hover:bg-clip-text hover:bg-gradient-primary w-full"
>
	<slot />
</span>
